import { ReactElement } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import { ICON_SIZES } from '../designSystem/icons/AppIcon';

type BackrsUserBadgeProps = Readonly<{
  variant: 'professional' | 'student' | 'provider' | 'foundations';
}>;

export const BackrsUserBadge = ({ variant }: BackrsUserBadgeProps): ReactElement => {
  const label = variant === 'professional' || variant === 'provider' ? 'B' : 'S';

  return <Box sx={backrsCircleSx}>{label}</Box>;
};

const backrsCircleSx: SxProps<Theme> = ({ backrs, typography }) => ({
  position: 'absolute',
  bottom: '0px',
  right: '0px',
  width: ICON_SIZES['24px'],
  height: ICON_SIZES['24px'],
  borderRadius: backrs.radius['radius-full'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: backrs.colors['Colors/Base/White'],
  ...typography['text-sm-semibold'],
  backgroundColor: backrs.colors['Brand/800'],
  border: `2px solid ${backrs.colors['Colors/Foreground/fg-primary']}`,
});
